export const translation = {
  zenit: {
    ru: {
      formTitle: "Регистрация",
      formSubtitle: "Создать аккаунт в Zenit",
      formSubtitleFinal: "Осталось два шага до Победы! Пополните счет и сделайте ставку!",
      phoneLabel: "Телефон",
      emailLabel: "Электронная почта",
      currencyLabel: "Выберите валюту",
      passwordLabel: "Введите пароль",
      regButtonText: "Регистрация",
      smsSentText: "SMS с кодом для подтверждения регистрации отправлено на номер телефона:",
      specifyDifferentNumberText: "Указать другой номер",
      confirmCodeTitle: "Код подтверждения",
      confirmCodeRepeatedRequest1: "Запросить код повторно можно через ",
      confirmCodeRepeatedRequest2: " секунд",
      confirmCodeRepeatedRequestLink: "Запросить код повторно",
      regsuccessfull: "Регистрация завершена успешно",
      regsuccessfulltext: `Осталось два шага до победы! 
          Пополни счет и сделай ставку!`,
      accountNumberTitle: "Ваш номер счета:",
      regButtonFinalText: "Перейти к пополнению",
      disclaimerText1: "Нажимая кнопку, вы соглашаетесь с ",
      disclaimerRules: "правилами",
      disclaimerText2: " приема и расчета ставок и ",
      disclaimerPrivacyPolicy: "политикой конфиденциальности",
      disclaimerText3: ", а также подтверждаете достоверность вышеуказанных данных.",
      disclaimerTextCupis: `Данный сайт защищен reCAPTCHA, <a href="https://policies.google.com/privacy">Политика конфиденциальности</a> и <a href="https://policies.google.com/terms">Пользовательское соглашение</a> компании Google остаются в силе.`,
      validateRecaptchaErr: "Проверь подключение к интернету и обнови страницу",
      phoneNumberErr: "Введите корректный номер телефона",
      passwordLengthErr: "Укажите от 6 до 30 символов латинского алфавита",
      promocodeErr: "Некорректный промокод",
      serverErr: "Сервер временно недоступен",
      smsCodeErr: "Введите корректный SMS код",
      privacyPolicy: "Политика конфиденциальности",
      betAcceptanceRules: "Правила приема ставок",
      emailLengthErr: 'Некорректный Email',
      search: "Поиск",
      promocodeSucces: 'Применен',
      promocodeLabel: 'Промокод'
    },
    uz: {
      formTitle: "Регистрация",
      formSubtitle: "ZENITDA AKKAUNT YARATISH",
      formSubtitleFinal: "Осталось два шага до Победы! Пополните счет и сделайте ставку!",
      phoneLabel: "Telefon",
      emailLabel: "Электронная почта",
      currencyLabel: "Valyuta",
      passwordLabel: "Parol",
      regButtonText: "ROʻYXAT OʻTISH",
      smsSentText: "SMS с кодом для подтверждения регистрации отправлено на номер телефона:",
      specifyDifferentNumberText: "Указать другой номер",
      confirmCodeTitle: "Код подтверждения",
      confirmCodeRepeatedRequest1: "Запросить код повторно можно через ",
      confirmCodeRepeatedRequest2: " секунд",
      confirmCodeRepeatedRequestLink: "Запросить код повторно",
      regsuccessfull: "Регистрация завершена успешно",
      regsuccessfulltext: `Осталось два шага до победы! 
          Пополни счет и сделай ставку!`,
      accountNumberTitle: "Ваш номер счета:",
      regButtonFinalText: "Перейти к пополнению",
      disclaimerText1: "Нажимая кнопку, вы соглашаетесь с ",
      disclaimerRules: "правилами",
      disclaimerText2: " приема и расчета ставок и ",
      disclaimerPrivacyPolicy: "политикой конфиденциальности",
      disclaimerText3: ", а также подтверждаете достоверность вышеуказанных данных.",
      disclaimerTextCupis: `Данный сайт защищен reCAPTCHA, <a href="https://policies.google.com/privacy">Политика конфиденциальности</a> и <a href="https://policies.google.com/terms">Пользовательское соглашение</a> компании Google остаются в силе.`,
      validateRecaptchaErr: "Проверь подключение к интернету и обнови страницу",
      phoneNumberErr: "Введите корректный номер телефона",
      passwordLengthErr: "Укажите от 6 до 30 символов латинского алфавита",
      promocodeErr: "Некорректный промокод",
      serverErr: "Сервер временно недоступен",
      smsCodeErr: "Введите корректный SMS код",
      privacyPolicy: "Политика конфиденциальности",
      betAcceptanceRules: "Правила приема ставок",
      emailLengthErr: 'Некорректный Email',
      search: "Поиск",
      promocodeSucces: 'Promo-kod topilmadi',
      promocodeLabel: 'Promo-kod'
    },
    kz: {
      formTitle: "Tіркеу",
      emailLabel: "Электрондық пошта",
      formSubtitle: "Букмекерлік кеңседе тіркелгі жасаңыз Zenit",
      formSubtitleFinal: "Жеңіске екі қадам қалды! Есептік жазбаңызды қаржыландырыңыз және ставка жасаңыз!",
      phoneLabel: "Телефон",
      currencyLabel: "Валютаны таңдаңыз",
      passwordLabel: "Құпия сөзді еңгізіңіз",
      regButtonText: "Тіркеу",
      smsSentText: "Телефон нөміріне тіркеуді растау коды бар SMS жіберілді:",
      regsuccessfull: "Тіркеу сәтті аяқталды",
      regsuccessfulltext: `Жеңіске екі қадам қалды! 
      Есептік жазбаңызды қаржыландырыңыз және ставка жасаңыз!`,
      specifyDifferentNumberText: "Басқа нөмірді көрсетіңіз",
      confirmCodeTitle: "Растау коды",
      confirmCodeRepeatedRequest1: "арқылы кодты қайта сұрауға болады ",
      confirmCodeRepeatedRequest2: " секунд",
      confirmCodeRepeatedRequestLink: "Кодты қайта сұраңыз",
      accountNumberTitle: "Сіздің шот нөміріңіз:",
      regButtonFinalText: "Толықтыруға өтіңіз",
      disclaimerText1: "Түймені басу арқылы сіз келісесіз ",
      disclaimerRules: "ережелер",
      disclaimerText2: " ставкаларды қабылдау және есептеу және ",
      disclaimerPrivacyPolicy: "құпиялылық саясаты",
      disclaimerText3: ", және де жоғарыда аталған деректердің дұрыстығын растаңыз.",
      validateRecaptchaErr: "Интернетке қосылуды тексеріп, бетті жаңартыңыз",
      phoneNumberErr: "Жарамды телефон нөмірін енгізіңіз",
      passwordLengthErr: "Латын әліпбиінің 6-дан 30 таңбасына дейін көрсетіңіз",
      promocodeErr: "Қате промо-код",
      serverErr: "Сервер уақытша қолжетімсіз",
      smsCodeErr: "Дұрыс SMS кодын енгізіңіз",
      privacyPolicy: "Құпиялық саясат",
      betAcceptanceRules: "Ұтыстарды қабылдау ережелері",
      search: "Іздеу",
      promocodeSucces: 'Қолданылған',
      promocodeLabel: 'Промокодты'
    },
    ua: {
      formTitle: "Регистрация",
      formSubtitle: "Создайте аккаунт в букмекерской конторе Zenit",
      formSubtitleFinal: "Осталось два шага до Победы! Пополните счет и сделайте ставку!",
      phoneLabel: "Телефон",
      emailLabel: "Электронная почта",
      currencyLabel: "Выберите валюту",
      passwordLabel: "Введите пароль",
      regButtonText: "Регистрация",
      regsuccessfull: "Регистрация завершена успешно",
      regsuccessfulltext: `Осталось два шага до победы! 
          Пополни счет и сделай ставку!`,
      smsSentText: "SMS с кодом для подтверждения регистрации отправлено на номер телефона:",
      specifyDifferentNumberText: "Указать другой номер",
      confirmCodeTitle: "Код подтверждения",
      confirmCodeRepeatedRequest1: "Запросить код повторно можно через ",
      confirmCodeRepeatedRequest2: " секунд",
      confirmCodeRepeatedRequestLink: "Запросить код повторно",
      accountNumberTitle: "Ваш номер счета:",
      regButtonFinalText: "Перейти к пополнению",
      disclaimerText1: "Нажимая кнопку, вы соглашаетесь с ",
      disclaimerRules: "правилами",
      disclaimerText2: " приема и расчета ставок и ",
      disclaimerPrivacyPolicy: "политикой конфиденциальности",
      disclaimerText3: ", а также подтверждаете достоверность вышеуказанных данных.",
      validateRecaptchaErr: "Проверь подключение к интернету и обнови страницу",
      phoneNumberErr: "Введите корректный номер телефона",
      passwordLengthErr: "Укажите от 6 до 30 символов латинского алфавита",
      promocodeErr: "Некорректный промокод",
      serverErr: "Сервер временно недоступен",
      smsCodeErr: "Введите корректный SMS код",
      privacyPolicy: "Политика конфиденциальности",
      betAcceptanceRules: "Правила приема ставок",
      search: "Поиск",
      promocodeSucces: 'Применен',
      promocodeLabel: 'Промокод'
    },
    en: {
      formTitle: "Registration",
      formSubtitle: "Create an account at Zenit",
      formSubtitleFinal: "Only two steps left to win! Fund your account and place a bet!",
      phoneLabel: "Phone",
      emailLabel: "Email",
      regsuccessfull: "Registration completed",
      regsuccessfulltext: `Just two more things to do! 
          Make a deposit and place your bet!`,

      currencyLabel: "Select currency",
      passwordLabel: "Enter password",
      regButtonText: "Registration",
      smsSentText: "A text message with the confirmation code has been sent to the phone number:",
      specifyDifferentNumberText: "Try a different number",
      confirmCodeTitle: "Confirmation code",
      confirmCodeRepeatedRequest1: "You are able to request the code again in ",
      confirmCodeRepeatedRequest2: " seconds",
      confirmCodeRepeatedRequestLink: "To request the code",
      accountNumberTitle: "Your account number:",
      regButtonFinalText: "Go to replenishment",
      disclaimerText1: "By clicking the button, you agree to the ",
      disclaimerRules: "Betting & Settlement Rules",
      disclaimerText2: " and ",
      disclaimerPrivacyPolicy: "Privacy Policy",
      disclaimerText3: ", and confirm the accuracy of the provided data.",
      validateRecaptchaErr: "Check your internet connection and refresh the page",
      phoneNumberErr: "Please enter a valid phone number",
      passwordLengthErr: "Specify from 6 to 30 characters of the Latin alphabet",
      promocodeErr: "Incorrect promo code",
      serverErr: "Server temporarily unavailable",
      smsCodeErr: "Enter correct SMS code",
      privacyPolicy: "Privacy Policy",
      betAcceptanceRules: "Rules for accepting bets",
      emailLengthErr: 'Incorrect Email',
      search: "Search",
      promocodeSucces: 'Applied',
      promocodeLabel: 'Promo code'
    },
  },
  zenbet: {
    ru: {
      formTitle: "Регистрация",
      formSubtitle: "Создайте аккаунт в букмекерской конторе Zenbet",
      formSubtitleFinal: "Осталось два шага до Победы! Пополните счет и сделайте ставку!",
      phoneLabel: "Телефон",
      emailLabel: "Электронная почта",
      currencyLabel: "Выберите валюту",
      passwordLabel: "Введите пароль",
      regButtonText: "Регистрация",
      smsSentText: "SMS с кодом для подтверждения регистрации отправлено на номер телефона:",
      specifyDifferentNumberText: "Указать другой номер",
      regsuccessfull: "Регистрация завершена успешно",
      regsuccessfulltext: `Осталось два шага до победы! 
          Пополни счет и сделай ставку!`,
      confirmCodeTitle: "Код подтверждения",
      confirmCodeRepeatedRequest1: "Запросить код повторно можно через ",
      confirmCodeRepeatedRequest2: " секунд",
      confirmCodeRepeatedRequestLink: "Запросить код повторно",
      accountNumberTitle: "Ваш номер счета:",
      regButtonFinalText: "Перейти к пополнению",
      disclaimerText1: "Нажимая кнопку, вы соглашаетесь с ",
      disclaimerRules: "правилами",
      disclaimerText2: " приема и расчета ставок и ",
      disclaimerPrivacyPolicy: "политикой конфиденциальности",
      disclaimerText3: ", а также подтверждаете достоверность вышеуказанных данных.",
      validateRecaptchaErr: "Проверь подключение к интернету и обнови страницу",
      phoneNumberErr: "Введите корректный номер телефона",
      passwordLengthErr: "Укажите от 6 до 30 символов латинского алфавита",
      promocodeErr: "Некорректный промокод",
      serverErr: "Сервер временно недоступен",
      smsCodeErr: "Введите корректный SMS код",
      privacyPolicy: "Политика конфиденциальности",
      betAcceptanceRules: "Правила приема ставок",
      emailLengthErr: 'Некорректный Email',
      search: "Поиск",
      promocodeSucces: 'Применен',
      promocodeLabel: 'Промокод'
    },
    en: {
      formTitle: "Registration",
      formSubtitle: "Create an account at Zenbet",
      formSubtitleFinal: "Only two steps left to win! Fund your account and place a bet!",
      phoneLabel: "Phone",
      emailLabel: "Email",
      currencyLabel: "Select currency",
      passwordLabel: "Enter password",
      regButtonText: "Registration",
      regsuccessfull: "Registration completed",
      regsuccessfulltext: `Just two more things to do! 
          Make a deposit and place your bet!`,
      smsSentText: "A text message with the confirmation code has been sent to the phone number:",
      specifyDifferentNumberText: "Try a different number",
      confirmCodeTitle: "Confirmation code",
      confirmCodeRepeatedRequest1: "You are able to request the code again in ",
      confirmCodeRepeatedRequest2: " seconds",
      confirmCodeRepeatedRequestLink: "To request the code",
      accountNumberTitle: "Your account number:",
      regButtonFinalText: "Go to replenishment",
      disclaimerText1: "By clicking the button, you agree to ",
      disclaimerRules: "rules",
      disclaimerText2: " accepting and calculating rates and ",
      disclaimerPrivacyPolicy: "privacy policy",
      disclaimerText3: ", and also confirm the accuracy of the above data.",
      validateRecaptchaErr: "Check your internet connection and refresh the page",
      phoneNumberErr: "Please enter a valid phone number",
      passwordLengthErr: "Specify from 6 to 30 characters of the Latin alphabet",
      promocodeErr: "Incorrect promo code",
      serverErr: "Server temporarily unavailable",
      smsCodeErr: "Enter correct SMS code",
      privacyPolicy: "Privacy Policy",
      betAcceptanceRules: "Rules for accepting bets",
      emailLengthErr: 'Incorrect Email',
      search: "Search",
      promocodeSucces: 'Applied',
      promocodeLabel: 'Promo code'
    },
    kz: {
      formTitle: "Tіркеу",
      emailLabel: "Электрондық пошта",
      formSubtitle: "Букмекерлік кеңседе тіркелгі жасаңыз Zenbet",
      formSubtitleFinal: "Жеңіске екі қадам қалды! Есептік жазбаңызды қаржыландырыңыз және ставка жасаңыз!",
      phoneLabel: "Телефон",
      currencyLabel: "Валютаны таңдаңыз",
      passwordLabel: "Құпия сөзді еңгізіңіз",
      regButtonText: "Тіркеу",
      smsSentText: "Телефон нөміріне тіркеуді растау коды бар SMS жіберілді:",
      regsuccessfull: "Тіркеу сәтті аяқталды",
      regsuccessfulltext: `Жеңіске екі қадам қалды! 
      Есептік жазбаңызды қаржыландырыңыз және ставка жасаңыз!`,
      specifyDifferentNumberText: "Басқа нөмірді көрсетіңіз",
      confirmCodeTitle: "Растау коды",
      confirmCodeRepeatedRequest1: "арқылы кодты қайта сұрауға болады ",
      confirmCodeRepeatedRequest2: " секунд",
      confirmCodeRepeatedRequestLink: "Кодты қайта сұраңыз",
      accountNumberTitle: "Сіздің шот нөміріңіз:",
      regButtonFinalText: "Толықтыруға өтіңіз",
      disclaimerText1: "Түймені басу арқылы сіз келісесіз ",
      disclaimerRules: "ережелер",
      disclaimerText2: " ставкаларды қабылдау және есептеу және ",
      disclaimerPrivacyPolicy: "құпиялылық саясаты",
      disclaimerText3: ", және де жоғарыда аталған деректердің дұрыстығын растаңыз.",
      validateRecaptchaErr: "Интернетке қосылуды тексеріп, бетті жаңартыңыз",
      phoneNumberErr: "Жарамды телефон нөмірін енгізіңіз",
      passwordLengthErr: "Латын әліпбиінің 6-дан 30 таңбасына дейін көрсетіңіз",
      promocodeErr: "Қате промо-код",
      serverErr: "Сервер уақытша қолжетімсіз",
      smsCodeErr: "Дұрыс SMS кодын енгізіңіз",
      privacyPolicy: "Құпиялық саясат",
      betAcceptanceRules: "Ұтыстарды қабылдау ережелері",
      search: "Іздеу",
      promocodeSucces: 'Қолданылған',
      promocodeLabel: 'Промокодты'
    },
    br: {
      formTitle: "Registre-se agora",
      emailLabel: "E-mail",
      formSubtitle: "Crie uma conta na Zenbet Bookmakers",
      formSubtitleFinal: "Faltam apenas duas coisas! Faça um depósito e depois faça a sua aposta!",
      phoneLabel: "Número de telefone",
      currencyLabel: "Moeda",
      passwordLabel: "Senha",
      regButtonText: "Registrar-se",
      smsSentText: "O código de verificação foi enviado via mensagem de texto para o número especificado",
      specifyDifferentNumberText: "Especifique um número de telefone diferente",
      confirmationCodeTitle: "Сódigo de confirmação",
      confirmCodeRepeatedRequest1: "Você poderá solicitar o código novamente em ",
      confirmCodeRepeatedRequest2: " segundos",
      confirmCodeRepeatedRequestLink: "Para solicitar o código",
      regsuccessfull: "Registration completed",
      regsuccessfulltext: `Just two more things to do! 
          Make a deposit and place your bet!`,
      accountNumberTitle: "Número da sua conta:",
      regButtonFinalText: "Ir aos depósitos",
      disclaimerText1: "Ao pressionar \"Registrar-se Agora\", você concorda com ",
      disclaimerRules: "Nossas Regras",
      disclaimerText2: " de Aceitação e Liquidação de Apostas e com a ",
      disclaimerPrivacyPolicy: "Política de Privacidade",
      disclaimerText3: ". Confirmo a exatidão dos dados apresentados acima.",
      validateRecaptchaErr: "Verifique sua conexão com a internet e atualize a página",
      phoneNumberErr: "Número de telefone incorreto inserido",
      passwordLengthErr: "Insira de 6 a 30 caracteres latinos",
      promocodeErr: "Código promocional incorreto digitado",
      serverErr: "Servidor não está disponível no momento (código de erro 2)",
      smsCodeErr: "Código de confirmação de SMS incorreto",
      privacyPolicy: "Política de privacidade",
      betAcceptanceRules: "Regras de aceitação de apostas",
      search: "Buscar",
      promocodeSucces: 'Aplicado',
      promocodeLabel: 'Código promocional'
    }
  },
  cupis: {
    ru: {
      formTitle: "Регистрация",
      formSubtitle: "Создайте аккаунт в букмекерской конторе Zenbet",
      formSubtitleCupis: "Создай аккаунт в БК Зенит",
      formSubtitleFinal: "Осталось два шага до Победы! Пополните счет и сделайте ставку!",
      phoneLabel: "Номер телефона",
      countryLabel: "Страна гражданства",
      emailLabel: "Электронная почта",
      currencyLabel: "Выберите валюту",
      passwordLabel: "Введите пароль",
      regButtonText: "Регистрация",
      regButtonText1: "Продолжить",
      smsSentText: "SMS с кодом для подтверждения регистрации отправлено на номер телефона:",
      specifyDifferentNumberText: "Указать другой номер",
      regsuccessfull: "Регистрация завершена успешно",
      regsuccessfulltext: `Осталось два шага до победы! 
          Пополни счет и сделай ставку!`,
      confirmCodeTitle: "Код подтверждения",
      confirmCodeRepeatedRequest1: "Запросить код повторно можно через ",
      confirmCodeRepeatedRequest2: " секунд",
      confirmCodeRepeatedRequestLink: "Запросить код повторно",
      accountNumberTitle: "Ваш номер счета:",
      checkboxText: `Настоящим подтверждаю, что ознакомлен и принимаю <a href="/documents/7_Политика Конфиденциальности от 01.10.21.pdf">политику конфиденциальности</a>, <a href="/company/rules">правила азартных игр</a>, приема ставок и выплаты выигрышей ООО “Инвест Гарант” и подтверждаю свое <a href="/documents/Согласие.01.10.2021.doc">согласие</a> на передачу и обработку персональных данных указанными лицами.`,
      cupisNewRegistrationConfirmRule: `Настоящим подтверждаю, что ознакомлен и принимаю политику компании в отношении персональных данных и даю <a target="_blank" href="https://zenit.win/agreements/agreement">согласие</a> на их передачу и обработку, а также принимаю <a target="_blank" href="https://zenit.win/agreements/offer">оферту</a> НКО «Мобильная карта» и даю <a target="_blank" href="https://zenit.win/documents/Согласие.01.10.2021.doc">согласие</a> на передачу данных и обработку моих персональных данных указанному лицу, принимаю <a target="_blank" href="https://zenit.win/documents/7_Политика Конфиденциальности от 01.10.21.pdf">политику компании о конфиденциальности</a>, о cookies, <a className="show-rules-box" target="_blank" href="https://zenit.win/company/rules">правила</a> азартной игры.`,
      regButtonFinalText: "Перейти к пополнению",
      disclaimerText1: "Нажимая кнопку, вы соглашаетесь с ",
      disclaimerRules: "правилами",
      disclaimerText2: " приема и расчета ставок и ",
      disclaimerPrivacyPolicy: "политикой конфиденциальности",
      disclaimerText3: ", а также подтверждаете достоверность вышеуказанных данных.",
      disclaimerTextCupis: `Данный сайт защищен reCAPTCHA, <a href="https://policies.google.com/privacy">Политика конфиденциальности</a> и <a href="https://policies.google.com/terms">Пользовательское соглашение</a> компании Google остаются в силе.`,
      validateRecaptchaErr: "Проверь подключение к интернету и обнови страницу",
      phoneNumberErr: "Введите корректный номер телефона",
      passwordLengthErr: "Укажите от 6 до 30 символов латинского алфавита",
      promocodeErr: "Некорректный промокод",
      serverErr: "Сервер временно недоступен",
      smsCodeErr: "Введите корректный SMS код",
      privacyPolicy: "Политика конфиденциальности",
      betAcceptanceRules: "Правила приема ставок",
      emailLengthErr: 'Некорректный Email',
      search: "Поиск",
      promocodeSucces: 'Применен',
      promocodeLabel: 'Промокод',
      birthdate: 'Дата рождения',
      firstAnnotation: 'Обязательно указывайте действительные данные!',
      secondAnnotation: 'Номер телефона и дата рождения проверяются в ЕДИНОМ ЦУПИС.'
    },
    en: {
      formTitle: "Registration",
      formSubtitle: "Create an account at Zenbet",
      formSubtitleFinal: "Only two steps left to win! Fund your account and place a bet!",
      phoneLabel: "Phone",
      emailLabel: "Email",
      currencyLabel: "Select currency",
      passwordLabel: "Enter password",
      regButtonText: "Registration",
      regsuccessfull: "Registration completed",
      regsuccessfulltext: `Just two more things to do! 
          Make a deposit and place your bet!`,
      smsSentText: "A text message with the confirmation code has been sent to the phone number:",
      specifyDifferentNumberText: "Try a different number",
      confirmCodeTitle: "Confirmation code",
      confirmCodeRepeatedRequest1: "You are able to request the code again in ",
      confirmCodeRepeatedRequest2: " seconds",
      confirmCodeRepeatedRequestLink: "To request the code",
      accountNumberTitle: "Your account number:",
      regButtonFinalText: "Go to replenishment",
      disclaimerText1: "By clicking the button, you agree to ",
      disclaimerRules: "rules",
      disclaimerText2: " accepting and calculating rates and ",
      disclaimerPrivacyPolicy: "privacy policy",
      disclaimerText3: ", and also confirm the accuracy of the above data.",
      validateRecaptchaErr: "Check your internet connection and refresh the page",
      phoneNumberErr: "Please enter a valid phone number",
      passwordLengthErr: "Specify from 6 to 30 characters of the Latin alphabet",
      promocodeErr: "Incorrect promo code",
      serverErr: "Server temporarily unavailable",
      smsCodeErr: "Enter correct SMS code",
      privacyPolicy: "Privacy Policy",
      betAcceptanceRules: "Rules for accepting bets",
      emailLengthErr: 'Incorrect Email',
      search: "Search",
      promocodeSucces: 'Applied',
      promocodeLabel: 'Promo code'
    },
    kz: {
      formTitle: "Tіркеу",
      emailLabel: "Электрондық пошта",
      formSubtitle: "Букмекерлік кеңседе тіркелгі жасаңыз Zenbet",
      formSubtitleFinal: "Жеңіске екі қадам қалды! Есептік жазбаңызды қаржыландырыңыз және ставка жасаңыз!",
      phoneLabel: "Телефон",
      currencyLabel: "Валютаны таңдаңыз",
      passwordLabel: "Құпия сөзді еңгізіңіз",
      regButtonText: "Тіркеу",
      smsSentText: "Телефон нөміріне тіркеуді растау коды бар SMS жіберілді:",
      regsuccessfull: "Тіркеу сәтті аяқталды",
      regsuccessfulltext: `Жеңіске екі қадам қалды! 
      Есептік жазбаңызды қаржыландырыңыз және ставка жасаңыз!`,
      specifyDifferentNumberText: "Басқа нөмірді көрсетіңіз",
      confirmCodeTitle: "Растау коды",
      confirmCodeRepeatedRequest1: "арқылы кодты қайта сұрауға болады ",
      confirmCodeRepeatedRequest2: " секунд",
      confirmCodeRepeatedRequestLink: "Кодты қайта сұраңыз",
      accountNumberTitle: "Сіздің шот нөміріңіз:",
      regButtonFinalText: "Толықтыруға өтіңіз",
      disclaimerText1: "Түймені басу арқылы сіз келісесіз ",
      disclaimerRules: "ережелер",
      disclaimerText2: " ставкаларды қабылдау және есептеу және ",
      disclaimerPrivacyPolicy: "құпиялылық саясаты",
      disclaimerText3: ", және де жоғарыда аталған деректердің дұрыстығын растаңыз.",
      validateRecaptchaErr: "Интернетке қосылуды тексеріп, бетті жаңартыңыз",
      phoneNumberErr: "Жарамды телефон нөмірін енгізіңіз",
      passwordLengthErr: "Латын әліпбиінің 6-дан 30 таңбасына дейін көрсетіңіз",
      promocodeErr: "Қате промо-код",
      serverErr: "Сервер уақытша қолжетімсіз",
      smsCodeErr: "Дұрыс SMS кодын енгізіңіз",
      privacyPolicy: "Құпиялық саясат",
      betAcceptanceRules: "Ұтыстарды қабылдау ережелері",
      search: "Іздеу",
      promocodeSucces: 'Қолданылған',
      promocodeLabel: 'Промокодты'
    },
    br: {
      formTitle: "Registre-se agora",
      emailLabel: "E-mail",
      formSubtitle: "Crie uma conta na Zenbet Bookmakers",
      formSubtitleFinal: "Faltam apenas duas coisas! Faça um depósito e depois faça a sua aposta!",
      phoneLabel: "Número de telefone",
      currencyLabel: "Moeda",
      passwordLabel: "Senha",
      regButtonText: "Registrar-se",
      smsSentText: "O código de verificação foi enviado via mensagem de texto para o número especificado",
      specifyDifferentNumberText: "Especifique um número de telefone diferente",
      confirmationCodeTitle: "Сódigo de confirmação",
      confirmCodeRepeatedRequest1: "Você poderá solicitar o código novamente em ",
      confirmCodeRepeatedRequest2: " segundos",
      confirmCodeRepeatedRequestLink: "Para solicitar o código",
      regsuccessfull: "Registration completed",
      regsuccessfulltext: `Just two more things to do! 
          Make a deposit and place your bet!`,
      accountNumberTitle: "Número da sua conta:",
      regButtonFinalText: "Ir aos depósitos",
      disclaimerText1: "Ao pressionar \"Registrar-se Agora\", você concorda com ",
      disclaimerRules: "Nossas Regras",
      disclaimerText2: " de Aceitação e Liquidação de Apostas e com a ",
      disclaimerPrivacyPolicy: "Política de Privacidade",
      disclaimerText3: ". Confirmo a exatidão dos dados apresentados acima.",
      validateRecaptchaErr: "Verifique sua conexão com a internet e atualize a página",
      phoneNumberErr: "Número de telefone incorreto inserido",
      passwordLengthErr: "Insira de 6 a 30 caracteres latinos",
      promocodeErr: "Código promocional incorreto digitado",
      serverErr: "Servidor não está disponível no momento (código de erro 2)",
      smsCodeErr: "Código de confirmação de SMS incorreto",
      privacyPolicy: "Política de privacidade",
      betAcceptanceRules: "Regras de aceitação de apostas",
      search: "Buscar",
      promocodeSucces: 'Aplicado',
      promocodeLabel: 'Código promocional'
    }
  }
}
